import { BN, ZERO } from '@velocity-exchange/sdk';
import {
	NEW_ORDER_SL_PAST_LIQ_WARNING,
	NEW_ORDER_SL_TOO_CLOSE_TO_LIQ_WARNING,
	OPEN_POSITION_SL_PAST_LIQ_WARNING,
	OPEN_POSITION_SL_TOO_CLOSE_TO_LIQ_WARNING,
} from 'src/constants/warnings';

/**
 * Checks if a trigger price is too close to a liquidation price for a stop loss order.
 * Prices should be passed in at trade precision
 * Returns a warning message if the prices are too close, null otherwise.
 */
export const useTriggerVersusLiqWarning = (
	triggerPrice: BN | undefined,
	liqPrice: BN | undefined,
	direction: 'long' | 'short',
	isExistingOrder: boolean
): string | null => {
	if (!triggerPrice || triggerPrice.isZero()) {
		return null;
	}

	const positionHasLiqPrice = liqPrice && liqPrice.gt(ZERO);

	if (!positionHasLiqPrice) return null;

	const isPastLiqPrice =
		(direction === 'long' && triggerPrice.lte(liqPrice)) ||
		(direction === 'short' && triggerPrice.gte(liqPrice));

	if (isPastLiqPrice) {
		if (isExistingOrder) {
			return OPEN_POSITION_SL_PAST_LIQ_WARNING;
		}
		return NEW_ORDER_SL_PAST_LIQ_WARNING;
	}

	const liqBuffer = liqPrice.mul(new BN(1)).div(new BN(100));
	const isTooCloseToLiqPrice =
		(direction === 'long' &&
			triggerPrice.lte(liqPrice.add(liqBuffer)) &&
			triggerPrice.gt(liqPrice)) ||
		(direction === 'short' &&
			triggerPrice.gte(liqPrice.sub(liqBuffer)) &&
			triggerPrice.lt(liqPrice));

	if (isTooCloseToLiqPrice) {
		if (isExistingOrder) {
			return OPEN_POSITION_SL_TOO_CLOSE_TO_LIQ_WARNING;
		}
		return NEW_ORDER_SL_TOO_CLOSE_TO_LIQ_WARNING;
	}

	return null;
};
